<div class="info-panel info-panel__container">
  <span class="info-panel__title" *ngIf="title">{{ title }}: </span>
  <span class="info-panel__text">{{ text }}</span>
</div>
